import { Injectable } from '@angular/core';
import { CredentialsDaoService } from '../credentials-dao.service';
import { Credentials } from 'src/app/_model/credentials';
import { KeyValuePersistenceService } from 'src/app/_services/persistence/key-value-persistence/key-value-persistence.service';

// CONSTANTS
const CREDENTIALS_KEY = 'credentials';

@Injectable()
export class CredentialsStorageDaoService implements CredentialsDaoService {
  constructor(private keyValueStorage: KeyValuePersistenceService) {}

  public saveCredentials(credentials: Credentials): Promise<void> {
    return this.keyValueStorage.store(CREDENTIALS_KEY, credentials);
  }
  public getCredentials(): Promise<Credentials> {
    return this.keyValueStorage.load(CREDENTIALS_KEY);
  }
  public async reset() {
    // Do nothing - a soft reset should not lose information of the current user
  }

  public async clear() {
    await this.keyValueStorage.delete(CREDENTIALS_KEY);
  }
}
